<template>
  <div class="projectinfo">
    <card1 :img="project.img"
           :title="project.title"
           :subTitle="project.subTitle"
           :txt="project.txt">
    </card1>
  </div>
</template>

<script>
import language from 'mixins/language' // 预留 多语言混入实例
import card1 from 'components/card1.vue'
export default {
  name: '',
  mixins: [language],
  props: [''],
  data () {
    return {
      id: 0,
      project: {},
      CN: {
        PROJECTS: [
          { id: 1, img: require('images/project/11.png'), title: '广州高德置地广场', subTitle: '', txt: '广州高德置地广场位于珠江新城CBD核心地段—花城广场公园两侧，从东到西横跨广州新中轴线，总建筑面积92万平方米。其中，商业部分逾20万平方米，由春、夏、秋、冬广场组成；写字楼约36万平方米，分别为A、B、C、D、E、F、G、H座等8座甲级写字楼；还有卓美亚酒店Jumeirah Hotel和卓美亚礼庭公寓Jumeirah Living，是集消费、商业及文化休闲于一体的大型商业项目。<br>珠江新城规划为广州新中央商务区，也是中国三大国家级中央商务区之一。广州高德置地广场位于珠江新城核心区域，地理位置优越。项目横跨珠江新城花城广场，西起华夏路（地铁珠江新城站），东至花城大道（地铁猎德站），是地铁3号线、5号线及APM线的上盖物业，周边甲级写字楼、高级住宅区林立，各种城市文化配套及旅游设施齐全，形成广州新城市文化生活的核心区。' },
          { id: 2, img: require('images/project/22.png'), title: '杭州高德置地广场', subTitle: '', txt: '杭州高德置地广场总建筑面积约42万平方米，包括商业部分优托邦时光（UTOPA TIMES）、写字楼OFFICE A、B、C三区、私邸ICON RESIDENCES 、卓美亚酒店Jumeirah Hotel，还配套有美术馆和UTOPA CLUB等。项目由世界级设计公司SOM担纲总体设计，建筑立面体现“站立的西湖”理念，带来风靡世界的生活社交空间。<br>杭州高德置地广场位于钱江新城CBD中心，是杭州政治、经济、文化新中心。市民中心、国际会议中心、杭州大剧院、城市阳台、波浪文化城等城市顶尖资源齐聚于此。周边交通畅达，地处地铁4号线和7号线上盖，邻近快速公交站。' },
          { id: 3, img: require('images/project/33.png'), title: 'UTOPA HUB', subTitle: '广州·奥体', txt: 'UTOPA HUB（广州·奥体）总建筑面积为27万平方米，是以满足区域家庭生活为导向，集购物、生活配套、运动健康、亲子娱乐、家居艺术等于一体。项目内划分数个主题商业区，提供多样化的社交体验服务，主要主题区包括美居生活、童年时光、天为食、活力基地及娱乐体验专区的家年华。项目还拥有多项休闲设施，包括户外儿童游乐场，室内溜冰场，室外攀岩场馆，足球场及篮球场。<br>UTOPA HUB（广州·奥体）位于广州市天河区东部奥体新城广园东快速路主干道，步行即可到达广州奥林匹克体育中心，是广州东部地区最大的社交体验空间。' },
          { id: 4, img: require('images/project/44.png'), title: 'UTOPA HUB', subTitle: '株洲·神农太阳城', txt: 'UTOPA HUB（株洲·神农太阳城），是株洲的城市地标级项目。总建筑面积达28万平方米，由南北两区、文化休闲街及写字楼组成。其中呈现6大主题商业空间，集时尚零售、餐饮、儿童娱乐、教育、运动、娱乐休闲、家居、文化艺术及服务配套于一体。<br>UTOPA HUB（株洲·神农太阳城）坐落株洲建设发展新区内，城市核心商圈—河西商圈核心位置，具有得天独厚的地理位置优势和美轮美奂的自然环境。' },
          { id: 5, img: require('images/project/55.png'), title: 'UTOPA HUB', subTitle: '广州·CBD', txt: 'UTOPA HUB（广州· CBD）总建筑面积约为7万平方米，由东西两翼及第五季组合而成。围绕广州珠江新城CBD区域商业环境的个性化特色，着重构建生活、工作、聚会等社交空间，满足家庭、商务、生活等需求。<br>该项目位于珠江新城CBD核心区内，公共交通设施便利。地处猎德地铁站上盖，可通过新光快速路、华南快速干线及猎德大桥等主要交通干道轻松到达。' },
          { id: 6, img: require('images/project/66.png'), title: 'UTOPA HUB', subTitle: '东莞·虎门', txt: 'UTOPA HUB（东莞·虎门）总建筑面积约5万平方米，具有五层零售空间，集儿童、教育、零售、餐饮、娱乐休闲、运动等于一体。<br>UTOPA HUB（东莞·虎门）位于广东省东莞市虎门中心城片区与中心城南片区交汇处——未来的虎门市中心，处于城市的主干道。交通便利，毗邻金捷路地铁站。' },
          { id: 7, img: require('images/project/77.png'), title: 'UTOPA HUB', subTitle: '广州·科学城店', txt: 'UTOPA HUB（广州·科学城）总建筑面积约9万平方米，由A、B两座组合而成，是广州科学城内首个经营的商业项目。以社区生活社交空间为情景设计，集时尚零售、餐饮、儿童、娱乐、教育等于一体，满足消费者的日常生活所需。<br>广州科学城是政府支持开发的科技园，是广州市东部发展战略的中心区域。UTOPA HUB（广州·科学城）位于区域的核心地带绿轴广场上，地处开泰大道，接连广深公路、广汕公路、环城高速公路及广州市地铁4号线及6号线，交通便利。' },
          { id: 8, img: require('images/project/88.png'), title: 'UTOPA HUB', subTitle: '广州·长兴', txt: 'UTOPA HUB（广州·长兴）总建筑面积约5万平方米，融合餐饮、时尚零售、休闲娱乐、生活服务4大商业功能，满足区域内人群的日常生活购物、休闲娱乐、健康运动、生活服务、社交聚会等消费需求。<br>UTOPA HUB（广州·长兴）位于广州天河北部四大商圈交汇点，长湴村与元岗村交界处，邻近主要商业及住宅开发项目，接连广汕公路、华南快速路、天河客运站及广州市地铁3号线，交通便利。' }
        ]
      },
      ZH: {
        PROJECTS: [
          { id: 1, img: require('images/project/11.png'), title: '廣州高德置地廣場', subTitle: '', txt: '廣州高德置地廣場位於珠江新城CBD核心地段—花城廣場公園兩側，從東到西橫跨廣州新中軸線，總建築面積92萬平方米。其中，商業部分逾20萬平方米，由春、夏、秋、冬廣場組成；寫字樓約36萬平方米，分別為A、B、C、D、E、F、G、H座等8座甲級寫字樓；還有卓美亞酒店Jumeirah Hotel和卓美亞禮庭公寓Jumeirah Living，是集消費、商業及文化休閒於一體的大型商業項目。 <br>珠江新城規劃為廣州新中央商務區，也是中國三大國家級中央商務區之一。廣州高德置地廣場位於珠江新城核心區域，地理位置優越。項目橫跨珠江新城花城廣場，西起華夏路（地鐵珠江新城站），東至花城大道（地鐵獵德站），是地鐵3號線、5號線及APM線的上蓋物業，周邊甲級寫字樓、高級住宅區林立，各種城市文化配套及旅遊設施齊全，形成廣州新城市文化生活的核心區。' },
          { id: 2, img: require('images/project/22.png'), title: '杭州高德置地廣場', subTitle: '', txt: '杭州高德置地廣場總建築面積約42萬平方米，包括商業部分優托邦時光（UTOPA TIMES）、寫字樓OFFICE A、B、C三區、私邸ICON RESIDENCES 、卓美亞酒店Jumeirah Hotel，還配套有美術館和UTOPA CLUB等。項目由世界級設計公司SOM擔綱總體設計，建築立面體現“站立的西湖”理念，帶來風靡世界的生活社交空間。 <br>杭州高德置地廣場位於錢江新城CBD中心，是杭州政治、經濟、文化新中心。市民中心、國際會議中心、杭州大劇院、城市陽台、波浪文化城等城市頂尖資源齊聚於此。周邊交通暢達，地處地鐵4號線和7號線上蓋，鄰近快速公交站。' },
          { id: 3, img: require('images/project/33.png'), title: 'UTOPA HUB', subTitle: '廣州·奧體', txt: 'UTOPA HUB（廣州·奧體）總建築面積為27萬平方米，是以滿足區域家庭生活為導向，集購物、生活配套、運動健康、親子娛樂、家居藝術等於一體。項目內劃分數個主題商業區，提供多樣化的社交體驗服務，主要主題區包括美居生活、童年時光、天為食、活力基地及娛樂體驗專區的家年華。項目還擁有多項休閒設施，包括戶外兒童遊樂場，室內溜冰場，室外攀岩場館，足球場及籃球場。 <br>UTOPA HUB（廣州·奧體）位於廣州市天河區東部奧體新城廣園東快速路主幹道，步行即可到達廣州奧林匹克體育中心，是廣州東部地區最大的社交體驗空間。' },
          { id: 4, img: require('images/project/44.png'), title: 'UTOPA HUB', subTitle: '株洲·神農太陽城', txt: 'UTOPA HUB（株洲·神農太陽城），是株洲的城市地標級項目。總建築面積達28萬平方米，由南北兩區、文化休閒街及寫字樓組成。其中呈現6大主題商業空間，集時尚零售、餐飲、兒童娛樂、教育、運動、娛樂休閒、家居、文化藝術及服務配套於一體。 <br>UTOPA HUB（株洲·神農太陽城）坐落株洲建設發展新區內，城市核心商圈—河西商圈核心位置，具有得天獨厚的地理位置優勢和美輪美奐的自然環境。' },
          { id: 5, img: require('images/project/55.png'), title: 'UTOPA HUB', subTitle: '廣州·CBD', txt: 'UTOPA HUB（廣州· CBD）總建築面積約為7萬平方米，由東西兩翼及第五季組合而成。圍繞廣州珠江新城CBD區域商業環境的個性化特色，著重構建生活、工作、聚會等社交空間，滿足家庭、商務、生活等需求。 <br>該項目位於珠江新城CBD核心區內，公共交通設施便利。地處獵德地鐵站上蓋，可通過新光快速路、華南快速乾線及獵德大橋等主要交通幹道輕鬆到達。' },
          { id: 6, img: require('images/project/66.png'), title: 'UTOPA HUB', subTitle: '東莞·虎門', txt: 'UTOPA HUB（東莞·虎門）總建築面積約5萬平方米，具有五層零售空間，集兒童、教育、零售、餐飲、娛樂休閒、運動等於一體。 <br>UTOPA HUB（東莞·虎門）位於廣東省東莞市虎門中心城片區與中心城南片區交匯處——未來的虎門市中心，處於城市的主幹道。交通便利，毗鄰金捷路地鐵站。' },
          { id: 7, img: require('images/project/77.png'), title: 'UTOPA HUB', subTitle: '廣州·科學城店', txt: 'UTOPA HUB（廣州·科學城）總建築面積約9萬平方米，由A、B兩座組合而成，是廣州科學城內首個經營的商業項目。以社區生活社交空間為情景設計，集時尚零售、餐飲、兒童、娛樂、教育等於一體，滿足消費者的日常生活所需。 <br>廣州科學城是政府支持開發的科技園，是廣州市東部發展戰略的中心區域。 UTOPA HUB（廣州·科學城）位於區域的核心地帶綠軸廣場上，地處開泰大道，接連廣深公路、廣汕公路、環城高速公路及廣州市地鐵4號線及6號線，交通便利。' },
          { id: 8, img: require('images/project/88.png'), title: 'UTOPA HUB', subTitle: '廣州·長興', txt: 'UTOPA HUB（廣州·長興）總建築面積約5萬平方米，融合餐飲、時尚零售、休閒娛樂、生活服務4大商業功能，滿足區域內人群的日常生活購物、休閒娛樂、健康運動、生活服務、社交聚會等消費需求。 <br>UTOPA HUB（廣州·長興）位於廣州天河北部四大商圈交匯點，長湴村與元崗村交界處，鄰近主要商業及住宅開發項目，接連廣汕公路、華南快速路、天河客運站及廣州市地鐵3號線，交通便利。' }
        ]
      }
    }
  },
  components: { card1 },
  watch: {
    language (newVal) {
      this.id = parseInt(this.$route.params.id) || 1
      this.showData.PROJECTS.forEach(p => {
        if (p.id === this.id) {
          this.project = p
        }
      })
    }
  },
  computed: {},
  created () {
    this.id = parseInt(this.$route.params.id) || 1
    this.showData.PROJECTS.forEach(p => {
      if (p.id === this.id) {
        this.project = p
      }
    })
  },
  mounted () { },
  methods: {}
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.projectinfo {
  padding-top: px2rem(44);
  /deep/ .card1-txt {
    line-height: px2rem(20);
  }
}
</style>
